import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  filtersContainer: {
    marginBottom: "16px",
    display: "flex",
    justifyContent: "space-between",
    gap: "12px",
  },
  flex: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    flexWrap: "wrap",
  },
  selectedCount: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
    fontSize: "18px",
  },
  quickFilters: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "24px",
    gap: "12px",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  fieldWrapper: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",

    flexWrap: "wrap",
    gap: "12px",

    [theme.breakpoints.down("md")]: {
      width: "100%",
    },

    [theme.breakpoints.down("426")]: {
      width: "100%",
      justifyContent: "flex-start",
      "& .MuiBox-root": {
        width: "100%",
      },
    },
  },
  selectFields: {
    display: "flex",
    gap: "12px",
    [theme.breakpoints.down("769")]: {
      width: "100%",
      flexWrap: "wrap",

      "& .MuiBox-root": {
        width: "auto",
      },
    },
  },
  datePickerBtn: {
    maxWidth: "160px",
    background: theme.palette.button.secondary_bg,
    borderRadius: "8px",
    display: "flex",
    gap: "8px",
    padding: "10px 16px",
    border: `1px solid ${theme.palette.button.secondary_border}`,
  },
  customSelect: {
    [theme.breakpoints.up("426")]: {
      width: "191px !important",
    },
    [theme.breakpoints.down("426")]: {
      width: "100% !important",
    },
  },
  customInputContainer: {
    width: "400px !important",
    [theme.breakpoints.down("426")]: {
      width: "100% !important",
    },
  },
}));
